import ApplicationDetail from '@src/pages/applicationDetail'
import ApplicationDetailEdit from '@src/pages/applicationDetailEdit'
import Counter from '@src/pages/counter'
import CustomerInto from '@src/pages/customerInto'
import Home from '@src/pages/home'
import LeaveInfo from '@src/pages/leaveInfo'
import login from '@src/pages/login'
import PlanDetail from '@src/pages/planDetail'
import PlanDetailEdit from '@src/pages/planDetailEdit'
import QrCode from '@src/pages/qr-code'
import ViewContract from '@src/pages/viewContract'
import {createBrowserHistory} from 'history'
import queryString from 'querystring'
import React from 'react'
import {Route, Router, Switch} from 'react-router-dom'
import KFPop from "@component/KFPop";

import AssureComponent from "@src/pages/assure";
import Agreement from '@src/pages/agreement'
import Forgot from '@src/pages/forgotPwd'
import Archive from '@src/pages/archive'
import ArchiveEdit from '@src/pages/archive/archiveEdit'
import ArchiveDetail from '@src/pages/archive/detail'

export const _history = createBrowserHistory()

export default function RouteComponent() {
	return (
		<Router history={_history}>
			<Switch>
				<Route path="/assure" component={AssureComponent}/>
				<Route path="/ag" component={Agreement}/>
				{/* 入口页面 */}
				<Route path="/login" component={login}/>
				<Route path="/" component={MainRoute}/>
			</Switch>
		</Router>
	)
}


export function MainRoute() {
	return <>
		{/* <KFPop/> */}
		<Switch>
			{/* 主页面 */}
			<Route path="/" exact component={Home}/>
			<Route path="/forgot" exact component={Forgot}/>
			{/* 分享二维码 */}
			<Route path="/qr-code" exact component={QrCode}/>
			{/* 客户进件 */}
			<Route path="/customer-into" exact component={CustomerInto}/>
			{/* 客户金融方案详情编辑 */}
			<Route path="/plan-detail-edit" exact component={PlanDetailEdit}/>
			{/* 客户金融方案详情查看 */}
			<Route path="/plan-detail" exact component={PlanDetail}/>
			{/* 客户合同 */}
			<Route path="/view-contract" exact component={ViewContract}/>
			{/* 客户留资 */}
			<Route path="/leave-info" exact component={LeaveInfo}/>
			{/* 计算器 */}
			<Route path="/counter" exact component={Counter}/>
			{/* 申请详情编辑 */}
			<Route
				path="/apply-detail-edit"
				exact
				component={ApplicationDetailEdit}
			/>
			{/* 申请详情 */}
			<Route path="/apply-detail" exact component={ApplicationDetail}/>

			<Route path="/archive" exact component={Archive}/>
			<Route path="/archiveEdit" exact component={ArchiveEdit}/>
			<Route path="/archiveDetail" exact component={ArchiveDetail}/>
		</Switch>
	</>
}


export function goto(path: string, query?: any) {
	if (query) {
		path = path + '?' + queryString.stringify(query)
	}
	_history.push(path)
	window.scrollTo(0, 0)
}

export function replaceTo(path: string, query?: any) {
	if (query) {
		path = path + '?' + queryString.stringify(query)
	}
	_history.replace(path)
	window.scrollTo(0, 0)
}

export function goBack() {
	_history.goBack()
	window.scrollTo(0, 0)
}
